
"use strict"; // jshint ignore:line

import { DragHandle } from '../services/DragHandlesService.js';

export default function CommentHandlersService( $rootScope, contextMenuService, dragHandlesService ) {

	$rootScope.commentHandlers = this;

	this.handlers_arr     = [];
	this.handlers_by_uuid = {};

	this.add = function( handler ) {
		if (this.handlers_arr.indexOf( handler ) != -1) return;

		if (handler.$uuid) {
			if (this.handlers_by_uuid[ handler.$uuid ]) throw "uuid conflict!";
			
			this.handlers_by_uuid[ handler.$uuid ] = handler;
		}

		this.handlers_arr.push( handler );
	};

	this.remove = function( handler ) {
		if (handler.$uuid) delete this.handlers_by_uuid[ handler.$uuid ];

		var idx = this.handlers_arr.indexOf( handler );
		if (idx != -1) this.handlers_arr.splice( idx, 1 );
	};

	CommentsHandler.Service = this;

	contextMenuService.buildTemplateScope( "templates/context-modals/comments.html", {
		removeComments: function( handler ) {
			handler.clear();
			if (handler.$parent instanceof DragHandle.Comment) {
				this.$modal.close();
				dragHandlesService.removeHandle( handler.$parent );
				CommentsHandler.Service.remove( handler );
			}
		}
	});
	contextMenuService.init( "comments", "templates/context-modals/comments.html", {
		addComment: function( comments, comment ){
			var len = comments.length;
			comments.push( comment );
			return comments.length > len;
		}
	});
}
CommentHandlersService.$inject = [ "$rootScope", "contextMenuService", "dragHandlesService" ];

/***********************************************/

/* Objektiin asetettava työkalu jolla hallinnoida */
export class CommentsHandler extends Array {

	constructor( parent, comments = null ) {

		super();

		if (CommentsHandler.Service) CommentsHandler.Service.add( this );
		
		this.$parent = null; // Jos asetettu kohdeobjekti johon kommentti kohdistuu
		this.$uuid  = null;

		if (parent) {
			this.$parent = parent;

			if (parent.uuid) {
				this.$uuid = parent.uuid;
			}
		}

		if (comments) this.push( comments );
	}

	clear() {
		this.splice( 0, this.length );
	}

	init( comments ) {
		this.clear( );

		this.push( comments );
	}

	push( ...argv ) {


		if (Array.isArray( argv[0] )) argv = argv[0];

		for (var a = argv, i = 0; i < a.length; i++) {
			Array.prototype.push.call( this, (a[i] instanceof Comment ? a[i] : new Comment( a[i] )));
		}
	}

	toJSON( arr ) {
		arr = arr || [];
		for (var i = 0; i < this.length; i++) arr.push( this[i].toJSON() );
		return arr;
	}
}

export class Comment {

	constructor( obj = {}, isStatic = false ) {

		if (typeof obj == "string") {
			obj = { text: obj, isStatic: isStatic };
		}

		/***/

		this.text = obj.text || "";

		this.isStatic = obj.isStatic || false;
	}

	toJSON() {
		return {
			text: this.text
		};
	}

	toString() {
		return this.text;
	}
}
